import React from 'react';
import { Table } from 'antd';
import styles from './BudgetTable.module.scss';

export default function BudgetTable({response}) {
const dataSource = [
    {
      key: 'subsidy',
      label: 'Επιδότηση',
      percentage: response.subsidy.percentage,
      amount: response.subsidy.amount,
    },
    {
      key: 'participation',
      label: 'Ίδια Συμμετοχή',
      percentage: response.participation.percentage,
      amount: response.participation.amount,
    },
    {
      key: 'loan',
      label: 'Τραπεζικός Δανεισμός',
      percentage: response.loan.percentage,
      amount: response.loan.amount,
    },
    {
      key: 'total',
      label: 'Σύνολο',
      percentage: response.total.percentage,
      amount: response.total.amount,
      isTotal: true,
    },
  ];

  const columns = [
    {
      title: 'Συνολικός Προϋπολογισμός ΕΣ',
      dataIndex: 'label',
      key: 'label',
       width: 300,
    },
    {
      title: '% Ποσοστό',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      width: 240,
      render: value => `${value}%`,
    },
    {
      title: 'Ποσό σε €',
      dataIndex: 'amount',
       width: 200,
      key: 'amount',
      align: 'right',
      render: value =>
        value?.toLocaleString('el-GR', {
          style: 'currency',
          currency: 'EUR',
        }),
    },
  ];

  return (
    <Table
        className={styles.budgetTable}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        rowClassName={record => (record.isTotal ? styles.totalRow : '')}
      />
  );
}
